import styled from 'styled-components';
import { colors, fonts } from 'stylesheets';
import TextButton from 'components/Button/TextButton';

export const Head = styled.thead`
  height: 36px;
  background: ${colors.greyLighter};
  border-top-left-radius: 2px;
  border-top-right-radius: 2px;
  border: none;
`;
export const HeadRow = styled.tr`
  border: none !important;
`;
export const Th = styled.th`
  padding: 0.5rem 1.5rem !important;
  border: none !important;
  font: 13px ${fonts.primary};
  color: ${colors.greyDark};
  text-transform: uppercase;
`;

export const BodyRow = styled.tr`
  height: 54px;
  background-color: ${colors.white};
  &:nth-of-type(odd) {
    background: ${colors.blueLight};
  }
`;

export const Td = styled.td`
  padding: 0.5rem 1.5rem !important;
  vertical-align: middle !important;
  font: 13px ${fonts.primary};
  color: ${colors.greyDark};
  height: 57px;
  &.actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    & .icons {
      min-width: 120px;
      padding-right: 10px;
    }
  }
`;

export const TextButtonStyled = styled(TextButton)`
  border: 1px solid ${colors.greyLighter} !important;
  transition: box-shadow 0.2s;
  img {
    width: 16px;
    height: 16px;
  }
  span {
    font-size: 11px;
  }
  &:hover {
    box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.25);
    transition: box-shadow 0.2s;
  }
`;
